import { render } from "./PartnersGallery.vue?vue&type=template&id=14fd09b3&scoped=true"
import script from "./PartnersGallery.vue?vue&type=script&lang=js"
export * from "./PartnersGallery.vue?vue&type=script&lang=js"

import "./PartnersGallery.vue?vue&type=style&index=0&id=14fd09b3&lang=sass&scoped=true"

import exportComponent from "/home/frappe/ONEFM_Landing_page/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14fd09b3"]])

export default __exports__